import type { AllHTMLAttributes } from 'react'

import cn from 'clsx'

import css from './iframe.module.css'
import { Box } from '@/components/Box/Box'

export type IframeProps = AllHTMLAttributes<HTMLIFrameElement>

export function IFrame({ src, children, title, className, ...rest }: IframeProps) {
    return (
        <Box className={cn(css.iframeContainer, css.bordered)}>
            <iframe src={src} className={className} {...rest}>
                {children}
            </iframe>
        </Box>
    )
}
